import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa";
import { RegisterB2BModel } from "./RegisterB2BModel";
import FormPart1 from "./FormPart1";
import FormPart2 from "./FormPart2";
import { post } from "../../api";
import { setErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import { B2B_REGISTER } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import EAAlert from "../shared/EAAlert";
import EAButton from "../shared/Buttons/EAButton";
import { State } from "../../store";
import { getRegisterB2BConfig } from "./registerB2BConfig";

interface IProps {
  onGoBack: () => void;
}

const RegisterB2BForm: React.FC<IProps> = ({ onGoBack }: IProps) => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const { configuration } = useSelector((state: State) => state.config);
  const [part, setPart] = useState<1 | 2 | 3>(1);
  const b2bConfig = getRegisterB2BConfig(facilityIds);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<RegisterB2BModel>({
    defaultValues: {
      acceptRule: false,
    },
  });

  const handleRegistration: SubmitHandler<RegisterB2BModel> = async (data) => {
    if (part === 1) {
      setPart(2);
    } else if (part === 2) {
      const { isError, errorTable } = await post(B2B_REGISTER(facilityIds), data);
      if (!isError) {
        setPart(3);
        reset();
        dispatch(setSuccessMessage("Wysłaliśmy Twoją prośbę o dołączenie do partnerów"));
      } else {
        dispatch(setErrors(errorTable));
      }
    }
  };

  return (
    <div className="register-b2b-form-wrapper">
      <div className="register-b2b-page-header">
        <div className="register-b2b-logo">
          {configuration?.logoUrl && (
            <img src={configuration.logoUrl} alt="Logo sklepu" />
          )}
        </div>
        <h2 className="text-centered no-margins">{b2bConfig.heading}</h2>
        <p className="text-centered">{b2bConfig.subheading}</p>
      </div>

      <div className="register-b2b-form">
        <form onSubmit={handleSubmit(handleRegistration)}>
          {part === 1 && (
            <>
              <FormPart1 errors={errors} register={register} />
              <div className="register-b2b-actions">
                <EAButton
                  title="Powrót"
                  variant="text"
                  startIcon={<FaArrowLeft />}
                  onClick={onGoBack}
                />
              </div>
            </>
          )}
          {part === 2 && (
            <>
              <FormPart2 errors={errors} register={register} control={control} />
              <div className="register-b2b-actions">
                <EAButton
                  title="Wróć"
                  variant="text"
                  startIcon={<FaArrowLeft />}
                  onClick={() => setPart(1)}
                />
              </div>
            </>
          )}
          {part === 3 && (
            <div className="register-b2b-form__success">
              <EAAlert type="success" message="Wysłaliśmy Twoją prośbę o dołączenie do partnerów" />
              <div className="register-b2b-actions" style={{ marginTop: "20px" }}>
                <EAButton
                  title="Powrót do sklepu"
                  variant="filled"
                  startIcon={<FaArrowLeft />}
                  onClick={onGoBack}
                />
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default RegisterB2BForm;
